import { ref } from 'vue'
import { isPromise } from 'gleam-shared/helpers/nodash'

export default function useInProgress(action, { inParallel = true } = {}) {
  let count = 0
  const inProgress = ref(false)
  return [inProgress, withProgress]

  function withProgress(...args) {
    const probe = action.apply(this, args)
    if (isPromise(probe)) {
      count++
      inProgress.value = true
      return probe.finally(() => {
        count--
        if (!inParallel || count === 0) {
          inProgress.value = false
        }
      })
    } else {
      return probe
    }
  }
}
